import { FC, SVGAttributes } from 'react';

const ArrowRight: FC<React.PropsWithChildren<React.PropsWithChildren<SVGAttributes<SVGElement>>>> = ({ ...props }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" shapeRendering="geometricPrecision" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.22179 4.22257C7.79222 4.65215 7.79222 5.34863 8.22179 5.77821L14.444 12.0004L8.22179 18.2226C7.79222 18.6522 7.79222 19.3486 8.22179 19.7782C8.65137 20.2078 9.34785 20.2078 9.77743 19.7782L16.7774 12.7782C17.207 12.3486 17.207 11.6521 16.7774 11.2226L9.77743 4.22257C9.34785 3.793 8.65137 3.793 8.22179 4.22257Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default ArrowRight;
